import React from 'react';
import { ContentBlock, Button, SvgIcon, Badge } from 'seduo-ui';
import DropdownWithIcon from '../examples/DropdownWithIcon';
const Example = () => (<ContentBlock>
        <div className="d-flex flex-column flex-xl-row flex-wrap justify-content-between align-content-between">
            <div className="d-flex flex-wrap align-items-center align-content-around mb-7 mb-md-0" style={{
        height: '125px',
    }}>
                <Button color="info" className="mr-5">
                    <span className="text-nowrap">
                        <SvgIcon kind="Filter" className="icon icon-white"/> Parametry (2)
                    </span>
                </Button>
                <Badge href="#" color="secondary" className="mr-5">
                    <span className="text-nowrap">
                        Čtení <SvgIcon kind="Close" className="icon icon-white icon--small"/>
                    </span>
                </Badge>
                <Badge href="#" color="secondary" className="mr-5">
                    <span className="text-nowrap">
                        Psaní <SvgIcon kind="Close" className="icon icon-white icon--small"/>
                    </span>
                </Badge>
                <span className="link text-nowrap">Zrušit filtry</span>
            </div>
            <div className="d-flex flex-column flex-md-row align-items-md-center">
                <span className="mr-4 text-nowrap">Řadit od</span>
                <DropdownWithIcon />
            </div>
        </div>
        <hr />
    </ContentBlock>);
export default Example;
